import { ReactNode, useEffect } from "react";
import { IntercomProvider, useIntercom } from "react-use-intercom";

import { INITIAL_CLIENT_DATA } from "../utils";

import variables from "client/common/styles/export-variables.less?export";

const OPEN_CHAT_SEARCH_PARAM = "chat";

type ClientIntercomProviderProps = {
  children: ReactNode;
};

const ClientIntercomContent = ({ children }: ClientIntercomProviderProps) => {
  const intercom = useIntercom();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(OPEN_CHAT_SEARCH_PARAM) === "open") {
      intercom.show();
      params.delete(OPEN_CHAT_SEARCH_PARAM);
      const newUrl = params.toString()
        ? `${window.location.pathname}?${params.toString()}${window.location.hash}`
        : `${window.location.pathname}${window.location.hash}`;
      window.history.replaceState({}, "", newUrl);
    }
  }, [intercom]);

  return <>{children}</>;
};

const ClientIntercomProvider = ({ children }: ClientIntercomProviderProps) => {
  const initialData = INITIAL_CLIENT_DATA;

  return (
    <IntercomProvider
      appId={initialData.intercom_id}
      autoBoot={!!initialData.intercom_id}
      autoBootProps={{
        userId: initialData.user_id?.toString(),
        userHash: initialData.intercom_user_hash || undefined,
        backgroundColor: variables.intercomColor,
        actionColor: variables.intercomColor,
        hideDefaultLauncher: true,
        customAttributes: {
          "Current Clinic ID": initialData.clinic.id,
          "Current Clinic Name": initialData.clinic.internal_name,
          ...(window.SETTINGS !== "production" && {
            "Base URL": window.location.origin,
          }),
        },
      }}
    >
      <ClientIntercomContent>{children}</ClientIntercomContent>
    </IntercomProvider>
  );
};

export default ClientIntercomProvider;
